import { AbsenceType, QueryFactory, ResourceType } from '@lmt/shared-types';
import { ResourceSettings } from '@lmt/unicorn-shared/app/components/calendar/visit/common/types';
import { getDateTimeInterval } from '@lmt/unicorn-shared/app/helpers/date-helper';
import { addDays, startOfDay } from 'date-fns';

const getDefaultInterval = () => {
  const start = startOfDay(new Date());
  const end = addDays(start, 1);
  return { start, end };
};

export const getDefaultAbsenceData = (data: {
  selectedInterval?: Interval;
  absenceId?: number;
}) => {
  return {
    title: '',
    reason: '',
    dateTimeInterval: data.absenceId
      ? {
          startDate: null,
          startTimeInMills: null,
          endDate: null,
          endTimeInMills: null,
        }
      : getDateTimeInterval(
          data.selectedInterval ? data.selectedInterval : getDefaultInterval(),
        ),
    absenceType: AbsenceType.Holiday,
    resources: {},
    note: '',
    acceptConflict: false,
  };
};

export function useAbsenceResourceSettings() {
  const resourceSettingsQuery =
    QueryFactory.ResourceSettingsQuery.useGetQuery();
  return {
    [ResourceType[ResourceType.Doctors]]: {
      isMultiSelect: true,
      isManualOrdering: resourceSettingsQuery.data?.doctorsManualOrdering,
    },
    [ResourceType[ResourceType.Places]]: {
      isMultiSelect: true,
      isManualOrdering: resourceSettingsQuery.data?.roomsManualOrdering,
    },
    [ResourceType[ResourceType.SpecialConditions]]: {
      isMultiSelect: true,
      isManualOrdering: resourceSettingsQuery.data?.equipmentManualOrdering,
    },
  };
}
